import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMetricsDurability = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M38.847 9.151 23.998 3 9.149 9.151 2.999 24l6.15 14.849L23.998 45l14.849-6.15L44.998 24zM24 37.708c-5.653-4.595-9.452-11.374-10.128-19.051a7.2 7.2 0 0 0 4.443-5.201A41 41 0 0 1 24 13.05c1.931 0 3.826.146 5.685.406a7.2 7.2 0 0 0 4.443 5.201C33.452 26.334 29.653 33.113 24 37.708" }) }) })
});
export default SvgMetricsDurability;
